package core.io

sealed class CustomHttpResponse<T> {
    data class Success<T>(val data: T) : CustomHttpResponse<T>()
    sealed class Error<T> : CustomHttpResponse<T>() {
        class NoInternet<T>() : Error<T>()
        class Timeout<T>() : Error<T>()
        class Unknown<T>() : Error<T>()
    }
}